import { Tab } from "@blueprintjs/core";
import * as React from "react";
import { useQuery } from "react-query";
import { useHistory, useParams } from "react-router";

import { UtilisateurCentresLiesSwitch, UtilisateurServicesLiesSwitch } from "..";
import { UtilisateurApi } from "../../../../api";
import { ERoutes } from "../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useAuth } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { UtilisateurDetailPage } from "./UtilisateurDetailPage";

export interface IUtilisateurItemPageProps {}

export const UtilisateurItemPage: React.FunctionComponent<IUtilisateurItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const api = useApiService(UtilisateurApi);
  const { user } = useAuth();

  const fetchDisplayName = React.useCallback(() => {
    return api.utilisateurGetDisplayName({ id: +id });
  }, [id, api]);
  const { data: displayName } = useQuery(["user-display-name", id], fetchDisplayName);

  return (
    <PageBase breadCrumbs={[{ text: t(ETLCodes.Collaborateurs), route: ERoutes.users }, { text: displayName }]}>
      <ProtectedTabs
        id="TabsUtilisateurs"
        onChange={newTabId => history.push(`${ERoutes.users}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.users}></BackButton>
        <Tab id="detail" title={t(ETLCodes.Detail)} panel={<UtilisateurDetailPage />} />
        {!!user && user.ifapmeSide?.includes("Walter") && (
          <Tab id="centres" title={t(ETLCodes.Centres)} panel={<UtilisateurCentresLiesSwitch />} disabled={+id <= 0} />
        )}
        {!!user && user.ifapmeSide?.includes("Hope") && (
          <Tab
            id="services"
            title={t(ETLCodes.ServicesAlternance)}
            panel={<UtilisateurServicesLiesSwitch />}
            disabled={+id <= 0}
          />
        )}
      </ProtectedTabs>
    </PageBase>
  );
};
